/**
 *
 * Asynchronously loads the component for SearchCase
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
